import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Phone, Sliders, ChevronDown } from "lucide-react";
import "./HeroSection.css";

const HeroSection = () => {
  return (
    <section className="hero">
      <div className="hero__bg" />
      <div className="hero__gradient" />
      <div className="hero__gradient-bottom" />

      <div className="hero__inner">
        <div className="hero__container">

          {/* <div className="hero__eyebrow">
            <span className="hero__eyebrow-dot" />
            <span className="hero__eyebrow-text">Trusted by 50,000+ homeowners</span>
          </div> */}

          <h1 className="hero__heading">
            Find Your <em>Dream</em>
            <br />
            Property Today
          </h1>

          <p className="hero__subheading">
            Discover exceptional homes and investment properties crafted for the
            way you want to live — effortless, transparent, and tailored to you.
          </p>

          <div className="hero__actions">
            <Link to="/property-list" className="hero__btn-primary">
              View Listings
              <ArrowRight size={16} strokeWidth={2.5} />
            </Link>

            <Link to="/contactus" className="hero__btn-secondary">
              <Phone size={15} strokeWidth={2} />
              Contact us
            </Link>

            <span className="hero__divider" />

            <Link to="/interiordesign" className="hero__btn-ghost">
              <Sliders size={13} />
              Share Your Query
            </Link>
          </div>
        </div>
      </div>

      <div className="hero__scroll">
        <div className="hero__scroll-line" />
        <ChevronDown size={14} color="rgba(255,255,255,0.4)" />
      </div>
    </section>
  );
};

export default HeroSection;